// Two-step sign-in with an authenticator app (src/helpers/twoFactor.ts on the server).
//
// Signing in to an account that has it on answers 403 with code MFA_REQUIRED and a
// short-lived token. The page then asks for the six digits from the app, or a recovery
// code, and trades them with the token for a session here.

import api from './Api';
import * as JKYModel from '../custom-types';

export const MFA_REQUIRED = 'MFA_REQUIRED';

export const signInWithCode = async (mfaToken: string, code: string): Promise<{ user: JKYModel.User; token: string }> => {
  const response = await api.auth('login/mfa', 'POST', { mfaToken, code: code.trim() });
  if (!response || !response.user || !response.token) {
    throw new Error('Sign-in did not work. Please try again.');
  }
  return { user: response.user, token: response.token };
};

/** Six digits, or a recovery code like k7m2-x9qp-4hdw. Null when it could be one. */
export const codeProblem = (code: string): string | null => {
  const clean = code.replace(/[\s-]/g, '');
  if (/^[0-9]{6}$/.test(clean) || /^[a-z0-9]{12}$/i.test(clean)) return null;
  return 'Enter the 6-digit code from your app, or one of your recovery codes.';
};

/** The recovery codes as a text file to keep. */
export const recoveryCodesText = (email: string, codes: string[]) =>
  [
    'Jookable recovery codes',
    `For ${email}`,
    '',
    'Each code works once, in place of the code from your authenticator app.',
    '',
    ...codes,
    '',
  ].join('\n');
